import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=d1c64696&scoped=true&"
import script from "./theme.vue?vue&type=script&lang=js&"
export * from "./theme.vue?vue&type=script&lang=js&"
import style0 from "./theme.vue?vue&type=style&index=0&id=d1c64696&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c64696",
  null
  
)

export default component.exports